import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  output,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';

import { AssetLabelComponent } from '../../../shared/components/asset-label/asset-label.component';
import { UserEntityIconsComponent } from '../../../shared/components/user-entity-icons/user-entity-icons.component';
import { FastTooltipDirective } from '../../../shared/directives/fast-tooltip.directive';
import { PermissionsDirective } from '../../../shared/directives/permissions.directive';
import { StopPropagationDirective } from '../../../shared/directives/stop-propagation.directive';
import { Permission } from '../../../shared/models/api/permissions.enum';
import { UserDateTimeFormatPipe } from '../../../shared/pipes/user-date-time-format.pipe';
import { IconButtonDirective } from '../../../ui/button/icon-button/icon-button.directive';
import { CrudListItemMetaComponent } from '../../../unified-crud/components/crud-list-item-meta/crud-list-item-meta.component';
import {
  DependencyType,
  dependencyTypeDisplayMapper,
} from '../../models/dependency-tree-item.model';
import { TreeItemViewModel } from '../../store/dependency-tree.store';

@Component({
  selector: 'semeris-dependency-tree-item',
  imports: [
    CommonModule,
    UserEntityIconsComponent,
    AssetLabelComponent,
    CrudListItemMetaComponent,
    MatIconModule,
    StopPropagationDirective,
    FastTooltipDirective,
    PermissionsDirective,
    RouterModule,
    IconButtonDirective,
    MatSlideToggle,
    UserDateTimeFormatPipe,
  ],
  templateUrl: './dependency-tree-item.component.html',
  styleUrls: ['./dependency-tree-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DependencyTreeItemComponent {
  public readonly item = input.required<TreeItemViewModel>();
  public readonly editMetadata = output<TreeItemViewModel>();
  public readonly changeActive = output<TreeItemViewModel>();

  public readonly dependencyTypeDisplayMapper = dependencyTypeDisplayMapper;
  public readonly Permission = Permission;
  public readonly DependencyType = DependencyType;

  public onEditMetadata() {
    this.editMetadata.emit(this.item());
  }

  public onActiveChange() {
    if (!this.item().entity?.disabled) {
      this.changeActive.emit(this.item());
    }
  }
}
